export enum GetterTypes {
  GET_USER_STATUS = "GET_USER_STATUS",
  GET_REQUEST_PASSWORD_RESET_STATUS = "GET_REQUEST_PASSWORD_RESET_STATUS",
  GET_REGISTER_VALIDATION_STATUS = "GET_REGISTER_VALIDATION_STATUS",
  GET_REGISTER_STATUS = "GET_REGISTER_STATUS"
}
